import React, { Fragment } from 'react';
import {
    Container,
} from 'reactstrap';

import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import ListGroupsPageTitle from '../../Layout/AppMain/ListGroupsPageTitle';
import ResourcesComponent from '../../Layout/AppMain/Resources';


export default function Resources() {
    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <ListGroupsPageTitle
                    heading="Resources"
                    subheading="Services, training and products for Seniors"
                    icon="lnr-laptop-phone icon-gradient bg-ripe-malin fontWeigth800"
                    showHomeBtn={true}
                />
                <Container>
                    <ResourcesComponent />
                </Container>
            </CSSTransitionGroup>
        </Fragment>
    );
}
